// extracted by mini-css-extract-plugin
module.exports = {"body":"styles_body__qjaQq","mainHeading":"styles_mainHeading__3L01r","divider":"styles_divider__3Fu3t"};